module.exports = __webpack_public_path__ + "static/59invgde-3cb8eabc27ebb62a4c2e9ca68b0d971f.gif";